import React, { useRef, useState, useEffect } from "react";
import styled from "styled-components";
import { AiOutlineLeftCircle, AiOutlineRightCircle } from "react-icons/ai";
import ModuleCard from "./ModuleCard";

export default function ModuleSlider( {data, batchName, viewMore=true} ) {
    const listRef = useRef();
    const [showControls, setShowControls] = useState(true);
    const elementWidth = 320;
    const [scrollX, setScrollX] = useState(0);

    const handleDirection = (direction) => {
        let x = 0;
        if (direction === "left") {
            x = scrollX + Math.round(window.innerWidth / 2);
            if (x > 0) {
                x = 0;
            }
        }
        if (direction === "right") {
            x = scrollX - Math.round(window.innerWidth / 2);
            const listW = (data.length * elementWidth) + elementWidth;
            if (window.innerWidth - listW > x) {
                x = window.innerWidth - listW;
            }           
        }
        setScrollX(x);
        listRef.current.style.transform = `translateX(${x}px)`;
    }

    const handleShowControls = () => {
        const y = listRef.current.getBoundingClientRect().top;
        if (y > 90){
            setShowControls(true);
        }
        else {
            setShowControls(false);
        }
    }

    useEffect(() => {
        window.addEventListener("scroll", handleShowControls, true);
        return () => {
          window.removeEventListener("scroll", handleShowControls, true);
        };
      }, []);

return (
    <Container
    className="flex column"
    showControls={showControls}
    onMouseEnter={() => handleShowControls()}
    onMouseLeave={() => setShowControls(false)}
    >
        {/* <h3> Module results </h3> */}
        <div className="wrapper">
            <div className={`slider-action left ${!showControls ? "none" : ""} flex j-center a-center`} >
                <AiOutlineLeftCircle onClick={() => handleDirection("left")} />
            </div>
            <div className="slider flex" ref={listRef}>
                {data.map((moduleInfo, index) => {
                    return <ModuleCard name={moduleInfo['name']} batchName={batchName} image={moduleInfo['image']} viewMore={viewMore} key={index} />
                })}
            </div>
            <div className={`slider-action right ${!showControls ? "none" : ""} flex j-center a-center`} >
                <AiOutlineRightCircle onClick={() => handleDirection("right")} id="myDiv" />
            </div>
        </div>
    </Container>
);
};

const Container = styled.div`
ap: 1rem;
position: relative;
padding: 2rem 0;
height: 100%;
h3 {
margin-left: 50px;
color: black;
}
.wrapper {
    .slider {
        width: max-content;
        gap: 1rem;
        transform: translateX(0px);
        transition: 0.3s ease-in-out;
        margin-left: 50px;
        height: max-content;
    }
    .slider-action {
        position: absolute;
        z-index: 99;
        height: 100%;
        top: 0;
        bottom: 0;
        width: 50px;
        transition: 0.3s ease-in-out;
        svg {
        font-size: 8rem;
        color: #f67b50;
        :hover{
            cursor: pointer;
          }
        }
    }
    .none {
        display: none;
    }
    .left {
        left: 0;
    }
    .right {
        right: 0;
    }
}
`;